import React, { useEffect } from 'react';

/**
 * Simple Toast notification component
 * Optional `actionLabel` + `onAction` for retry (e.g. config load — F19).
 */
const Toast = ({
  message,
  type = 'info',
  isVisible,
  onClose,
  duration = 3000,
  actionLabel,
  onAction,
}) => {
  useEffect(() => {
    if (isVisible && duration > 0 && !(actionLabel && onAction)) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose, actionLabel, onAction]);

  if (!isVisible) return null;

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    warning: 'bg-yellow-500',
    info: 'bg-blue-500',
  }[type] || 'bg-gray-500';

  return (
    <div
      className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      aria-label={message}
    >
      <div className={`${bgColor} text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-[90vw]`}>
        <span className="flex-1">{message}</span>
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="shrink-0 rounded border border-white/80 px-3 py-1 text-sm font-semibold hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            {actionLabel}
          </button>
        ) : null}
        <button
          onClick={onClose}
          className="text-white hover:text-gray-200 font-bold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-transparent rounded"
          aria-label="Tutup"
        >
          ×
        </button>
      </div>
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translate(-50%, -10px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Toast;

